import { render, staticRenderFns } from "./ResultList.vue?vue&type=template&id=31f386bf&scoped=true"
import script from "./ResultList.vue?vue&type=script&lang=js"
export * from "./ResultList.vue?vue&type=script&lang=js"
import style0 from "./ResultList.vue?vue&type=style&index=0&id=31f386bf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f386bf",
  null
  
)

export default component.exports